module.exports = __webpack_public_path__ + "media/images/gallery/constellations/corona_australis/cra_dir-9e78c787bf213a62e1681d80e328074b.gif";